export default __webpack_public_path__ + "static/media/saint_aubin9.e65ecac6.jpg";